import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/customer/update/many/user.customer.update.many.mutation.gql"
import type {
  UserCustomerUpdateManyMutation,
  UserCustomerUpdateManyMutationVariables,
} from "@/v2-backoffice-client/user/customer/update/many/__types__/user.customer.update.many.mutation"

type Options = MutationHookOptions<
  UserCustomerUpdateManyMutation,
  UserCustomerUpdateManyMutationVariables
>

export function useUserCustomerUpdateManyMutation(options?: Options) {
  return useMutation<
    UserCustomerUpdateManyMutation,
    UserCustomerUpdateManyMutationVariables
  >(mutation, options)
}
